/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Compax Frontend API-v2
 * API by Compax
 * OpenAPI spec version: 161.0.0-SNAPSHOT
 */

export type GetEvnForCustomerSortDirection =
  (typeof GetEvnForCustomerSortDirection)[keyof typeof GetEvnForCustomerSortDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEvnForCustomerSortDirection = {
  asc: "asc",
  desc: "desc",
} as const;
